if (!customElements.get('toggle-cross-sell')) {
  customElements.define(
    'toggle-cross-sell',

    class ToggleCrossSell extends HTMLElement {
      constructor() {
        super();

        this.main_product_form =
          this.closest('.product').querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (this.main_product_form === null) return console.error('ToggleCrossSell: No product form found');
      }

      connectedCallback() {
        // Si on clique autour bouton ou de la checkbox, on veut quand même toggle le cross-sell
        this.addEventListener('click', this.onToggleProduct.bind(this));
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          // On écoute les changement de variante
          if (product.querySelector('select') != null) {
            product.querySelector('select').addEventListener('change', this.variantChanged.bind(this, product));
          }
          // On écoute les clics sur le bouton d'ajout
          if (product.querySelector('.button') != null) {
            product
              .querySelector('.button')
              .addEventListener('click', this.toggleAddButton.bind(this, product.querySelector('.button')));
          }
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onToggleProduct.bind(this));
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          if (product.querySelector('select') != null) {
            product.querySelector('select').removeEventListener('change', this.variantChanged.bind(this, product));
          }
          if (product.querySelector('.button') != null) {
            product
              .querySelector('.button')
              .removeEventListener('click', this.toggleAddButton.bind(this, product.querySelector('.button')));
          }
        });
      }

      // Change l'état du bouton d'ajout
      toggleAddButton(button, active) {
        if (button.classList.contains('button--secondary') || active == true) {
          button.classList.add('button--active');
          button.classList.remove('button--secondary');
        } else {
          button.classList.remove('button--active');
          button.classList.add('button--secondary');
        }
      }

      onToggleProduct(event) {
        const checkbox = event.target.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = !checkbox.checked;
        const button_add = event.target.querySelector('.button');
        if (button_add) this.toggleAddButton(button_add);
        this.updateMainFormInputs();
      }

      variantChanged(product) {
        const select = product.querySelector('select');
        const optionSelected = select.options[select.selectedIndex];
        this.updateProductPrice(product, optionSelected);
        this.updateProductImage(product, optionSelected);
        this.updateVariantId(product, optionSelected);
      }

      updateProductPrice(product, optionSelected) {
        const variantPrice = optionSelected.dataset.price;
        const compareAtPrice = product.querySelector('.toggle-cross-sell__product-compare-at-price');
        const badgeDiscount = product.querySelector('.toggle-cross-sell__product-badge-discount');
        product.querySelector('.toggle-cross-sell__product-price').innerHTML = variantPrice;

        if (optionSelected.dataset.compareAtPrice != null) {
          if (badgeDiscount != null) {
            compareAtPrice.innerHTML = optionSelected.dataset.compareAtPrice;
            compareAtPrice.style.display = 'block';
          }
          if (badgeDiscount != null) {
            badgeDiscount.innerHTML = optionSelected.dataset.discountText;
            badgeDiscount.style.display = 'flex';
          }
        } else {
          if (badgeDiscount != null) compareAtPrice.style.display = 'none';
          if (badgeDiscount != null) badgeDiscount.style.display = 'none';
        }
      }

      updateProductImage(product, optionSelected) {
        if (
          optionSelected.dataset.variantImage != null &&
          product.querySelector('.toggle-cross-sell__product-image') != null
        ) {
          const variantImage = optionSelected.dataset.variantImage;
          product.querySelector('.toggle-cross-sell__product-image img').src = variantImage;
        }
      }

      updateVariantId(product, optionSelected) {
        const variantId = optionSelected.value;
        const checkbox = product.querySelector('input[type="checkbox"]');
        const button_add = product.querySelector('.button');
        if (checkbox != null) {
          checkbox.dataset.variantId = variantId;
          checkbox.checked = true;
        }
        if (button_add != null) {
          button_add.dataset.variantId = variantId;
          this.toggleAddButton(button_add, true);
        }
        this.updateMainFormInputs();
      }

      resetMainFormInputs() {
        this.main_product_form.querySelectorAll('.from-toggle-cross-sell').forEach((input) => input.remove());
      }

      updateMainFormInputs() {
        this.resetMainFormInputs();

        this.querySelectorAll('.toggle-cross-sell__product').forEach((product, index) => {
          const checkbox = product.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            this.main_product_form.insertAdjacentHTML(
              'beforeend',
              `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${checkbox.dataset.variantId}">`,
            );
          }

          const button_add = product.querySelector('.button');
          if (button_add && button_add.classList.contains('button--active')) {
            this.main_product_form.insertAdjacentHTML(
              'beforeend',
              `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${button_add.dataset.variantId}">`,
            );
          }
        });
      }
    },
  );
}
